module.exports = __webpack_public_path__ + "site/img/51.296fc160.jpg";